import Card from './Card';
export default Card;

export { default as CardBody } from './CardBody';
export { default as CardTitle } from './CardTitle';
export { default as CardText } from './CardText';
export { default as CardDeck } from './CardDeck';
